const SKIP_PRINTING = 'SKIP_PRINTING';

module.exports = SKIP_PRINTING;
